import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, onFocus, onChange, ...props }, ref) => {
  // For numeric inputs, auto-select the contents on focus so that typing a
  // digit REPLACES the current value instead of being appended to it. This
  // prevents the "pre-filled 0 turns 35 into 350" class of bug across the
  // whole app without having to touch each form.
  const handleFocus = (e) => {
    if (type === "number") {
      try { e.target.select(); } catch {}
    }
    if (onFocus) onFocus(e);
  };
  // Also strip a leading "0" when the user types the first non-zero digit on
  // top of a field that still shows "0" (e.g. "0" + user types "3" -> "3",
  // not "03"). Safe because any legitimate "0.xx" still passes through once
  // the dot or non-zero digit arrives.
  const handleChange = (e) => {
    if (type === "number" && typeof e.target.value === "string") {
      const v = e.target.value;
      if (/^0\d/.test(v)) {
        e.target.value = v.replace(/^0+/, "") || "0";
      }
    }
    if (onChange) onChange(e);
  };
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      onFocus={handleFocus}
      onChange={handleChange}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
